import * as React from 'react';

export interface IQueryBuilderDragState {
  sourcePath: string;
  sourceHavingType?: string;
  targetPath: string;
}

const DragStateContext = React.createContext<IQueryBuilderDragState | undefined>(undefined);

export const QueryBuilderDragStateProvider = DragStateContext.Provider;

export function useQueryBuilderDragState(): IQueryBuilderDragState | undefined {
  return React.useContext(DragStateContext);
}

/** A rule can only move to a list holding the same having type, since that is where its field exists. */
export function isDropTargetForbidden(dragState: IQueryBuilderDragState | undefined, havingType: string | undefined): boolean {
  return !!dragState && dragState.sourceHavingType !== havingType;
}

export function isDropTargetDisabled(dragState: IQueryBuilderDragState | undefined, path: string | undefined, havingType: string | undefined): boolean {
  if (!dragState || !path) return false;
  if (isDropTargetForbidden(dragState, havingType)) return true;
  // Nested lists cover the same screen area and dnd resolves that overlap to the outermost one,
  // so only the list the dragged rule is actually over is left open
  return dragState.targetPath !== path;
}

/** The innermost rule list the dragged rule is over, which is the list dnd should drop it into. */
export function findListUnderDraggedRule(): string | undefined {
  const dragged = document.querySelector('.queryBuilder__draggable-row--dragging');
  if (!dragged) return undefined;

  const box = dragged.getBoundingClientRect();
  const elements = document.elementsFromPoint(box.left + box.width / 2, box.top + box.height / 2);
  for (const element of elements) {
    if (!dragged.contains(element)) {
      const list = element.closest('[data-rfd-droppable-id]');
      if (list) return list.getAttribute('data-rfd-droppable-id') ?? undefined;
    }
  }
  return undefined;
}

const DragCloneContext = React.createContext(false);

export const DragCloneProvider = DragCloneContext.Provider;

export function useIsRenderedInDragClone(): boolean {
  return React.useContext(DragCloneContext);
}
